import { RESET_MESSAGE_STORE, SHOW_MESSAGE } from './MessageType';

export function resetMessageStore() {
  return dispatch => dispatch({ type: RESET_MESSAGE_STORE });
}

export function showMessage(message) {
  return dispatch => dispatch({ type: SHOW_MESSAGE, payload: message });
}
